/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_COSTUME_TYPE } from "../graphql/getCostumeFeatures.query";
import { pretty } from "@vlinder-web/utils-react";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { GET_CURRENCY_EXCHANGE_RATE } from "../graphql/getCurrencyExchangeRate.query";
import { GET_BOXES } from "../graphql/getBoxes.query";
import { GET_BANDS } from "../graphql/getBands.query";

const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetCostumeTypeMethods extends IPluginMethodMap {
  getCostumeType(args: any): Promise<any>;
}

export class GetCostumeTypeService implements IAgentPlugin {
  readonly methods: IGetCostumeTypeMethods;
  private exchangeRate: any = 1;

  constructor() {
    this.methods = {
      getCostumeType: this.getCostumeType.bind(this),
    };
  }

  async getCostumeType(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const storageService = StorageModule.getInstance();
    const localStorage = storageService?.get("currencyExchangeLocal", "local");

    try {
      if (client) {
        let presentationArray: any = [];

        let data: any[] = [];
        let band;
        if (is.existy(localStorage?.band)) {
          band = localStorage?.band;
        }
        console.log("band1======>", localStorage);
        const res1 = await client.query({
          query: GET_BANDS,
          variables: {
            filter: {
              bandName: band,
            },
          },
          fetchPolicy: "network-only",
        });
        const boxRes = await client.query({
          query: GET_BOXES,
          variables: {},
          fetchPolicy: "network-only",
        });

        if (
          boxRes?.data?.getMyBoxes?.content &&
          boxRes?.data?.getMyBoxes?.content.length > 0
        ) {
          data = boxRes?.data?.getMyBoxes?.content;

          for (let obj of data) {
            if (obj?.presentation?.name && is.existy(obj?.presentation?.name)) {
              if (!presentationArray.includes(obj?.presentation?.name)) {
                presentationArray.push(obj?.presentation?.name);
              }
            }
          }
          console.log(
            "res1?.data?.getBand?.isMultiplePurchase === false",
            res1?.data?.getBand?.isMultiplePurchase === false,
            Array.isArray(data),
            data.length > 0
          );
          if (
            res1?.data?.getBand?.isMultiplePurchase === false &&
            Array.isArray(data) &&
            data.length > 0
          ) {
            const hasActive = data.some(
              (item) => item.presentation?.status?.toLowerCase() === "active"
            );
            console.log(
              "res1?.data?.getBand?.isMultiplePurchase === false",
              hasActive
            );
            if (hasActive) {
              return {
                redirect: "goToOrders",
              };
            }
          }
        }
        const res = await client.query({
          query: GET_COSTUME_TYPE,
          variables: {
            filter: {
              _id: args,
            },
          },
          fetchPolicy: "network-only",
        });
        const _res = await client.query({
          query: GET_CURRENCY_EXCHANGE_RATE,
          fetchPolicy: "network-only",
        });

        if (_res?.data?.getCurrencyExchangeRate) {
          storageService.set(
            "currencyExchangeLocal",
            _res?.data?.getCurrencyExchangeRate,
            "local"
          );
          storageService.set(
            "currencyExchangeSession",
            _res?.data?.getCurrencyExchangeRate,
            "session"
          );
        }
        this.exchangeRate = res?.data?.getCurrencyExchangeRate?.conversion_rate;
        if (res?.data?.getCostumeType) {
          const payload = this.formatData(res?.data?.getCostumeType);
          console.log("cos56", pretty(res?.data?.getCostumeType));
          return {
            ...payload,
            bandCurrency: res?.data?.getCurrencyExchangeRate?.currency,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private formatCostumeFeaturesList(data: any) {
    const emptyObj = { name: "...", id: "", isVisible: true };
    if (data && is.existy(data) && is.not.empty(data)) {
      for (let featureObj of data) {
        if (
          is.existy(featureObj) &&
          is.existy(featureObj?.costumeAttributes) &&
          is.not.empty(featureObj?.costumeAttributes)
        ) {
          let visibleFeatureCount: number = 0;
          for (let attributeObj of featureObj?.costumeAttributes) {
            if (is.existy(attributeObj) && attributeObj?.isVisible) {
              visibleFeatureCount++;
            }

            if (
              is.existy(attributeObj) &&
              is.existy(attributeObj?.costumeValues) &&
              is.not.empty(attributeObj?.costumeValues)
            ) {
              let visibleCostumeCount: number = 0;
              for (let costumeObj of attributeObj?.costumeValues) {
                if (
                  is.existy(costumeObj) &&
                  is.existy(costumeObj) &&
                  is.not.empty(costumeObj) &&
                  costumeObj?.isVisible
                ) {
                  visibleCostumeCount++;
                }
              }
              if (
                visibleCostumeCount > 0 &&
                !attributeObj?.costumeValues.some((e: any) => e.name === "...")
              ) {
                attributeObj?.costumeValues.unshift(emptyObj);
              }
            }
          }
          if (
            visibleFeatureCount > 0 &&
            !featureObj?.costumeAttributes.some((e: any) => e.name === "...")
          ) {
            featureObj?.costumeAttributes.unshift(emptyObj);
          }
        }
      }
    }

    return data;
  }

  private formatData(data: any) {
    console.log("data127", data);
    return {
      headers: {
        presentation: data?.presentation,
        section: data?.section,
        costumeTypeName: data?.name,
        costumeTypeID: data?.id,
        costumeTypeMinDownPayment: data?.minDownPayment,
        status: "Ready",
      },
      costumeFeaturesList: this.formatCostumeFeaturesList(
        data?.costumeFeatures
      ),
      exchangeRate: this.exchangeRate,
    };
  }
}
